export default __webpack_public_path__ + "static/media/SEC-1.0cabdfac.jpg";